import React from 'react';
import { Card } from 'react-bootstrap';
import HostsListItem from './HostsListItem/HostsListItem';
import { Form } from 'react-bootstrap';
import { Nav } from "react-bootstrap";

const { Header, Body } = Card;

const hostsList = (props) => {
    const title = props.state !== undefined ? props.group === 'global' ? 'Global Properties' : props.group === 'hosts' ? 'Hosts' : props.state.groups[props.group].label : null;
    let items = [];

    items = props.hosts.map((hostname, index) => (
        <HostsListItem
            key={props.group + '_host_' + index}
            index={index}
            group={props.group}
            hostname={hostname.name}
        />
    ));

    if(items.length === 0){
        items.push(
            <Form.Text key={props.group + '_nohost'} className="text-muted"><em>No hosts currently defined for {title}. If required add "{title}" to a new or existing host from the "Hosts" menu.</em></Form.Text>
        );
    }

    return (
        <Card className='hosts-area'>
            <Header as="h6">Hosts </Header>
            <Body>
                {items}
            </Body>
        </Card>
    )
};

export default hostsList;
